module.exports = __webpack_public_path__ + "static/media/customer-sleepy-owl.e62379ae.png";